<apx-chart
  [series]="chartOptions.series"
  [chart]="chartOptions.chart"
  [labels]="chartOptions.labels"
  [responsive]="chartOptions.responsive"
  [colors]="chartOptions.colors"
  [legend]="chartOptions.legend"
  [dataLabels]="chartOptions.dataLabels"
></apx-chart>
